import { createAsyncThunk } from "@reduxjs/toolkit";
import { getQuickAccessFolders } from "../../Api/HomeApiServices";
import { mapQuickAccessLists } from "../Types/Home/QuickAccessList";

// get all spending project list
export const getAllQuickAccessData = createAsyncThunk('getAllSpendingProjectList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getQuickAccessFolders();
  
    if (response.status) {
      return mapQuickAccessLists(response.body['data']);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});